export class OrangeBookJsEnv {
  inputWord: string;
  refineKbn: string;
  callBackKbn: string;
  llCategoryCode: string;
  lCategoryCode: string;

  constructor(
    inputWord: string,
    refineKbn: string,
    callBackKbn: string,
    llCategoryCode: string,
    lCategoryCode: string
  ) {
    this.inputWord = inputWord;
    this.refineKbn = refineKbn;
    this.callBackKbn = callBackKbn;
    this.llCategoryCode = llCategoryCode;
    this.lCategoryCode = lCategoryCode;
  }
}
